/** Generates trace IDs and tab IDs for diagnostic correlation. */

export function generateTraceId(): string {
	// 8-hex timestamp + 16-hex random → 25 chars total
	const ts = Date.now().toString(16);
	const rand =
		typeof crypto !== 'undefined' && 'randomUUID' in crypto
			? crypto.randomUUID().replace(/-/g, '').slice(0, 16)
			: Math.random().toString(16).slice(2, 18).padEnd(16, '0');
	return `${ts}-${rand}`;
}

let cachedTabId: string | null = null;

export function getTabId(): string {
	if (cachedTabId !== null) return cachedTabId;
	try {
		const stored = sessionStorage.getItem('amos.tabId');
		if (stored) {
			cachedTabId = stored;
		} else {
			cachedTabId =
				typeof crypto !== 'undefined' && 'randomUUID' in crypto
					? crypto.randomUUID()
					: `tab-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
			sessionStorage.setItem('amos.tabId', cachedTabId);
		}
	} catch {
		cachedTabId =
			typeof crypto !== 'undefined' && 'randomUUID' in crypto
				? crypto.randomUUID()
				: `tab-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
	}
	return cachedTabId;
}
